import { render, staticRenderFns } from "./TrasladoBien.vue?vue&type=template&id=08071bc6"
import script from "./TrasladoBien.vue?vue&type=script&lang=js"
export * from "./TrasladoBien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports